import type { AnchorHTMLAttributes } from 'react';
import { Link as GatsbyLink } from 'gatsby';

type Props = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & { to: string };

/** Site pages go through Gatsby's Link (prefetch, client-side navigation); app and external URLs are plain anchors. */
export default function Link({ to, ...rest }: Props) {
  if (/^(https?:|mailto:|tel:)/.test(to)) return <a href={to} {...rest} />;
  return <GatsbyLink to={to} {...(rest as object)} />;
}
